import { c as _c } from "react/compiler-runtime";
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoRefresh16 } from '@onefootprint/icons';
import { Dropdown, useConfirmationDialog, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
import runWorkflow from '../run-workflow';
type ResumeWorkflowItemProps = {
  onboardingId: string;
};
const ResumeWorkflowItem = t0 => {
  const $ = _c(20);
  const {
    onboardingId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardingTraceDialog.resumeWorkflow"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    authHeaders
  } = useSession();
  const {
    toast
  } = useToast();
  const showErrorToast = useRequestErrorToast();
  const confirm = useConfirmationDialog();
  let t2;
  if ($[1] !== authHeaders || $[2] !== onboardingId) {
    t2 = () => runWorkflow(authHeaders, {
      id: onboardingId
    });
    $[1] = authHeaders;
    $[2] = onboardingId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t || $[5] !== toast) {
    t3 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[4] = t;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showErrorToast || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: showErrorToast
    };
    $[7] = showErrorToast;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const mutation = useMutation(t4);
  let t5;
  if ($[11] !== confirm || $[12] !== mutation || $[13] !== t) {
    t5 = () => {
      confirm.open({
        title: t(_temp3),
        description: t(_temp4),
        primaryButton: {
          label: t(_temp5),
          onClick: () => mutation.mutate(undefined)
        },
        secondaryButton: {
          label: t(_temp6)
        }
      });
    };
    $[11] = confirm;
    $[12] = mutation;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleResume = t5;
  let t6;
  if ($[15] !== t) {
    t6 = t(_temp7);
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== handleResume || $[18] !== t6) {
    t7 = <Dropdown.Item iconLeft={IcoRefresh16} onSelect={handleResume}>{t6}</Dropdown.Item>;
    $[17] = handleResume;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default ResumeWorkflowItem;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.toast.description;
}
function _temp3($_1) {
  return $_1.confirm.title;
}
function _temp4($_2) {
  return $_2.confirm.description;
}
function _temp5($_3) {
  return $_3.confirm.cta;
}
function _temp6($_4) {
  return $_4.confirm.cancel;
}
function _temp7($_5) {
  return $_5.label;
}